import { defineComponent, ref, watch } from 'vue';
import HetaoLogoNoc from '@/assets/image/home/logo_noc.png';
import HetaoDefaultAvatar from '@/assets/image/home/contest/default-avatar.png';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import { SHOW_BRAND } from '@/utils';
export default defineComponent({
  name: 'ContestHeader',
  components: {
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function () {
    var selectedKeys = ref([]);
    var route = useRoute();
    var router = useRouter();
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var logout = function () {
      userService.logout();
      // if (route.meta?.logoutPath) {
      //   const newQuery = route.meta?.ignoreQuery ? {} : route.query;
      //   router.replace({
      //     path: route.meta.logoutPath as string,
      //     query: newQuery,
      //   });
      // }
    };
    watch(function () {
      return userService.user;
    }, function (user) {
      if (!(user && user.userId)) {
        if (route.meta && route.meta.auth) {
          router.replace({
            name: route.meta.loginUrlName
          });
        }
      }
    });
    var HetaoLogoFinal = HetaoLogoNoc;
    var goLoginPage = function () {
      router.push({
        name: route.meta.loginUrlName
      });
    };
    return {
      HetaoLogoFinal: HetaoLogoFinal,
      selectedKeys: selectedKeys,
      loginService: loginService,
      userService: userService,
      logout: logout,
      SHOW_BRAND: SHOW_BRAND,
      goLoginPage: goLoginPage,
      HetaoDefaultAvatar: HetaoDefaultAvatar
    };
  }
});